import 'classlist-polyfill';

import wrapper from 'wrapper';

import Pocket from './components/pocket/pocket';
import Chart from './components/chart/chart';
import Table from './components/table/table';

import InputHandler from './components/input/handle-input';

function IEcustomEvents() {
    if (typeof window.CustomEvent === 'function') return false;

    function CustomEvent(event, params) {
        const param = params || { bubbles: false, cancelable: false, detail: undefined };
        const evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, param.bubbles, param.cancelable, param.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
}

function main() {
    const root = wrapper.select('#newsspec-26926');
    const pocket = new Pocket(root.querySelector('.pocket'));
    pocket.connect();

    root.classList.remove('no-js');

    new Table();

    new Chart();

    /* eslint-disable no-undef */
    const regionInclude = typeof newsspec26926region !== 'undefined' ? newsspec26926region : undefined;
    new InputHandler(regionInclude);
    /* eslint-enable */

    wrapper.markPageAsLoaded();
}

IEcustomEvents();

main();
